/*
  Algolia-powered search results page.

  Renders into the static shell produced by the "algolia_enabled" branch of
  sections/main-search.liquid, reusing existing theme classes (product-facet,
  product-item, pagination, popover...) and the generic custom elements already
  defined in theme.js (facet-filters, sort-by-popover, page-pagination,
  collapsible-content, quick-buy-popover/drawer). Those elements only compute a
  URL and dispatch a bubbling custom event ("facet:criteria-changed" /
  "pagination:page-changed") — the actual data fetching below is our own, talking
  directly to Algolia instead of Shopify's native section rendering.

  Facets come straight from the index's attributesForFaceting (vendor + the
  product metafields also shown in snippets/product-scheda-tecnica.liquid).
  There is no price or availability facet.
*/
(function () {
  "use strict";

  var config = window.themeVariables && window.themeVariables.algolia;
  if (!config || !config.enabled || !config.appId || !config.searchApiKey) {
    return;
  }

  var root = document.getElementById("algolia-search-results");
  var configScript = document.getElementById("algolia-search-config");
  // /search?view=popular (sections/main-search-popular.liquid): same product cards, fixed list
  var popularRoot = document.getElementById("algolia-popular-products");
  if (!popularRoot && (!root || !configScript)) {
    return;
  }

  var pageConfig = configScript ? JSON.parse(configScript.textContent) : {};
  var FACETS = [
    "vendor",
    "meta.data.typeChem",
    "meta.data.typeStrum",
    "meta.data.materiale",
    "meta.custom.diametro",
    "meta.data.sup_esterni",
    "meta.data.sporcoEst",
    "meta.data.sporcoInt",
    "meta.data.difetti",
    "meta.data.durata",
    "meta.data.formula"
  ];
  var FACET_LABELS = {
    vendor: "Marca",
    "meta.data.typeChem": "Tipo chimico",
    "meta.data.typeStrum": "Tipo strumento",
    "meta.data.materiale": "Materiale",
    "meta.custom.diametro": "Diametro",
    "meta.data.sup_esterni": "Superfici esterne",
    "meta.data.sporcoEst": "Sporco esterno",
    "meta.data.sporcoInt": "Sporco interno",
    "meta.data.difetti": "Difetti",
    "meta.data.durata": "Durata",
    "meta.data.formula": "Formula"
  };

  var filterListEl = document.getElementById("algolia-filter-list");
  var productListEl = document.getElementById("algolia-product-list");
  var paginationEl = document.getElementById("algolia-pagination");
  var countEl = document.getElementById("algolia-results-count");
  var emptyStateEl = document.getElementById("algolia-empty-state");
  var emptyQueryEl = document.getElementById("algolia-empty-query");
  var facetMainEl = document.getElementById("facet-main");
  var sortSelectedValueEl = document.getElementById("algolia-sort-by-selected-value");
  var activeFiltersEl = document.getElementById("algolia-active-filters");
  var activeFiltersMobileEl = document.getElementById("algolia-active-filters-mobile");
  var activeFiltersCountEl = document.getElementById("algolia-active-filters-count");
  var activeFiltersCountMobileEl = document.getElementById("algolia-active-filters-count-mobile");
  var clearFiltersLinkEl = document.getElementById("algolia-clear-filters-link");

  var abortController = null;

  var CLOSE_ICON_SVG =
    '<svg focusable="false" width="10" height="10" viewBox="0 0 14 14"><path d="M13 13L1 1M13 1L1 13" stroke="currentColor" stroke-width="' +
    (window.themeVariables.settings.iconStrokeWidth || 2) + '" fill="none"></path></svg>';

  function formatMoney(amount, format) {
    var settings = window.themeVariables.settings;
    format = format || (settings.currencyCodeEnabled ? settings.moneyWithCurrencyFormat : settings.moneyFormat);
    var cents = Math.round((amount || 0) * 100);
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? "," : thousands;
      decimal = decimal == null ? "." : decimal;
      number = (number / 100).toFixed(precision);
      var parts = number.split(".");
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : "";
      return dollars + centsPart;
    }

    var value = "";
    switch (format.match(placeholderRegex)[1]) {
      case "amount": value = withDelimiters(cents, 2); break;
      case "amount_no_decimals": value = withDelimiters(cents, 0); break;
      case "amount_with_space_separator": value = withDelimiters(cents, 2, " ", "."); break;
      case "amount_with_comma_separator": value = withDelimiters(cents, 2, ".", ","); break;
      case "amount_with_apostrophe_separator": value = withDelimiters(cents, 2, "'", "."); break;
      case "amount_no_decimals_with_comma_separator": value = withDelimiters(cents, 0, ".", ","); break;
      case "amount_no_decimals_with_space_separator": value = withDelimiters(cents, 0, " "); break;
      case "amount_no_decimals_with_apostrophe_separator": value = withDelimiters(cents, 0, "'"); break;
    }
    return format.replace(placeholderRegex, value);
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value).replace(/[&<>"']/g, function (char) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[char];
    });
  }

  function dedupeById(hits) {
    var seen = {};
    var result = [];
    for (var i = 0; i < hits.length; i++) {
      if (seen[hits[i].id]) continue;
      seen[hits[i].id] = true;
      result.push(hits[i]);
    }
    return result;
  }

  // Facet keys are dotted metafield paths (e.g. "meta.data.typeChem"); dots break CSS id
  // selectors used by the native toggle-button/collapsible-content elements, so DOM ids use
  // a dash-safe version while the real dotted key stays in the checkbox `name`.
  function domId(facetKey) {
    return "algolia-filter-" + facetKey.replace(/\./g, "-");
  }

  function paramsFromUrl(url) {
    return new URL(url, window.location.origin).searchParams;
  }

  function currentState() {
    var params = paramsFromUrl(window.location.href);
    var filters = {};
    FACETS.forEach(function (facet) {
      var values = params.getAll("filter." + facet);
      if (values.length) filters[facet] = values;
    });
    return {
      q: params.get("q") || "",
      page: Math.max(parseInt(params.get("page") || "1", 10), 1),
      sortBy: params.get("sort_by") || "",
      filters: filters
    };
  }

  function urlWithout(mutator) {
    var url = new URL(window.location.href);
    mutator(url.searchParams);
    url.searchParams.delete("page");
    return url.pathname + "?" + url.searchParams.toString();
  }

  function urlWithoutFilterValue(facet, value) {
    return urlWithout(function (params) {
      var remaining = params.getAll("filter." + facet).filter(function (v) { return v !== value; });
      params.delete("filter." + facet);
      remaining.forEach(function (v) { params.append("filter." + facet, v); });
    });
  }

  function urlClearAll() {
    return urlWithout(function (params) {
      var keys = [];
      params.forEach(function (_, key) {
        if (keys.indexOf(key) === -1) keys.push(key);
      });
      keys.forEach(function (key) {
        if (key !== "q" && key !== "sort_by") params.delete(key);
      });
    });
  }

  function indexNameForSort(sortBy) {
    if (sortBy === "price-ascending") return config.indexNamePriceAsc || config.indexName;
    if (sortBy === "price-descending") return config.indexNamePriceDesc || config.indexName;
    return config.indexName;
  }

  // --- Response cache ---
  // Algolia bills every request: back/forward, removing and re-adding a filter or coming back
  // from a product page would otherwise repeat identical queries. Raw responses are kept in
  // sessionStorage (same tab only) for CACHE_TTL_MS, keyed by index + request body. The TTL
  // stays well under the 1h Algolia accepts for a queryID in click/conversion events, so
  // insights sent from a cached page are still attributed to the original search.
  var CACHE_STORAGE_KEY = "algolia_results_cache";
  var CACHE_TTL_MS = 10 * 60 * 1000;
  var CACHE_MAX_ENTRIES = 20;

  function readCache() {
    try {
      var entries = JSON.parse(sessionStorage.getItem(CACHE_STORAGE_KEY) || "[]");
      var now = Date.now();
      return Array.isArray(entries) ? entries.filter(function (entry) { return entry && now - entry.time < CACHE_TTL_MS; }) : [];
    } catch (e) {
      return [];
    }
  }

  function cachedResponse(key) {
    var entry = readCache().find(function (entry) { return entry.key === key; });
    return entry ? entry.data : null;
  }

  function storeResponse(key, data) {
    var entries = readCache().filter(function (entry) { return entry.key !== key; });
    entries.unshift({ key: key, time: Date.now(), data: data });
    entries = entries.slice(0, CACHE_MAX_ENTRIES);
    // Quota exceeded (big pages): drop the oldest entries until it fits, or give up
    while (entries.length) {
      try {
        sessionStorage.setItem(CACHE_STORAGE_KEY, JSON.stringify(entries));
        return;
      } catch (e) {
        entries.pop();
      }
    }
  }

  async function fetchAlgolia(state, signal) {
    var indexName = indexNameForSort(state.sortBy);
    var endpoint = "https://" + config.appId + "-dsn.algolia.net/1/indexes/" + encodeURIComponent(indexName) + "/query";

    var facetFilters = Object.keys(state.filters).map(function (facet) {
      return state.filters[facet].map(function (value) {
        return facet + ":" + value;
      });
    });

    var body = JSON.stringify({
      query: state.q,
      page: state.page - 1,
      hitsPerPage: pageConfig.productsPerPage,
      distinct: true,
      clickAnalytics: true,
      facets: FACETS,
      facetFilters: facetFilters.length ? facetFilters : void 0
    });
    var cacheKey = indexName + "|" + body;
    var result = cachedResponse(cacheKey);

    if (!result) {
      var response = await fetch(endpoint, {
        method: "POST",
        signal: signal,
        headers: {
          "X-Algolia-Application-Id": config.appId,
          "X-Algolia-API-Key": config.searchApiKey,
          "Content-Type": "application/json"
        },
        body: body
      });

      if (!response.ok) {
        throw new Error("Algolia search request failed with status " + response.status);
      }

      result = await response.json();
      storeResponse(cacheKey, result);
    }

    result.hits = dedupeById(result.hits || []);
    result.indexName = indexName;

    if (window.algoliaInsights) {
      window.algoliaInsights.rememberSearch(indexName, result.queryID, result.hits);
    }

    return result;
  }

  function renderCount(nbHits) {
    var template = nbHits === 1 ? pageConfig.productsCountOne : pageConfig.productsCountOther;
    countEl.textContent = template.replace(/\d+/, nbHits);
  }

  function renderSortSelectedValue(state) {
    if (!sortSelectedValueEl) return;
    var checked = document.querySelector('#algolia-sort-by-popover [name="sort_by"][value="' + (state.sortBy || "") + '"]');
    sortSelectedValueEl.textContent = checked ? checked.title : "";
    document.querySelectorAll('#algolia-sort-by-popover [name="sort_by"]').forEach(function (input) {
      input.checked = input.value === state.sortBy;
    });
  }

  function renderCheckboxFacet(facetKey, facetValues, activeValues) {
    var entries = Object.keys(facetValues || {});
    if (!entries.length) return "";

    var id = domId(facetKey);
    var isOpen = activeValues.length > 0;
    var selectedValueHtml = activeValues.length
      ? '<span class="collapsible-toggle__selected-value text--subdued text--small hidden-tablet-and-up">' + escapeHtml(activeValues.join(", ")) + "</span>"
      : "";

    var html =
      '<div class="product-facet__filter-item">' +
      '<button type="button" is="toggle-button" class="collapsible-toggle text--strong" aria-controls="' + id + '" aria-expanded="' + isOpen + '">' +
      escapeHtml(FACET_LABELS[facetKey] || facetKey) +
      selectedValueHtml +
      '<svg focusable="false" width="12" height="8" class="icon icon--chevron icon--inline" viewBox="0 0 12 8"><path fill="none" d="M1 1l5 5 5-5" stroke="currentColor" stroke-width="' + (window.themeVariables.settings.iconStrokeWidth || 2) + '"></path></svg>' +
      "</button>" +
      '<collapsible-content animate-items ' + (isOpen ? "open" : "") + ' id="' + id + '" class="collapsible">' +
      '<div class="collapsible__content">' +
      entries.map(function (value, index) {
        var checked = activeValues.indexOf(value) !== -1;
        var inputId = id + "-" + index;
        return (
          '<div class="checkbox-container">' +
          '<input class="checkbox" type="checkbox" name="filter.' + facetKey + '" id="' + inputId + '" value="' + escapeHtml(value) + '" ' + (checked ? "checked" : "") + ">" +
          '<label for="' + inputId + '">' + escapeHtml(value) + " (" + facetValues[value] + ")</label>" +
          "</div>"
        );
      }).join("") +
      "</div></collapsible-content></div>";
    return html;
  }

  // Mirrors ProductFacet._filterItemKey in theme.js.
  function filterItemKey(item) {
    var toggle = item.querySelector(":scope > .collapsible-toggle[aria-controls]");
    return toggle ? toggle.getAttribute("aria-controls") : null;
  }

  // Mirrors ProductFacet._preserveMissingFilterValues in theme.js: a value that no longer
  // comes back from Algolia (because it now has 0 matches) stays visible but disabled with
  // "(0)", instead of abruptly disappearing from under the user.
  function preserveMissingFilterValues(oldItem, newItem) {
    var newKeys = {};
    Array.from(newItem.querySelectorAll('input[type="checkbox"]')).forEach(function (input) {
      newKeys[input.name + "::" + input.value] = true;
    });
    Array.from(oldItem.querySelectorAll(".checkbox-container")).forEach(function (wrapper) {
      var input = wrapper.querySelector('input[type="checkbox"]');
      if (!input || newKeys[input.name + "::" + input.value]) return;
      input.disabled = true;
      wrapper.classList.add("is-disabled");
      var label = wrapper.querySelector("label");
      if (label && /\(\d+\)/.test(label.textContent)) {
        label.textContent = label.textContent.replace(/\(\d+\)/, "(0)");
      }
      var container = newItem.querySelector(".collapsible__content");
      if (container) container.appendChild(wrapper);
    });
  }

  // Mirrors ProductFacet._preserveMissingFilterOptions in theme.js: a whole facet group that
  // no longer comes back from Algolia is re-inserted, zeroed out and disabled, rather than
  // vanishing outright.
  function preserveMissingFilterOptions(oldFilterList, newFilterList) {
    var newItemsByKey = {};
    Array.from(newFilterList.children).forEach(function (item) {
      var key = filterItemKey(item);
      if (key) newItemsByKey[key] = item;
    });
    Array.from(oldFilterList.children).forEach(function (oldItem, index) {
      var key = filterItemKey(oldItem);
      if (!key) return;
      var newItem = newItemsByKey[key];
      if (!newItem) {
        Array.from(oldItem.querySelectorAll('input[type="checkbox"]')).forEach(function (input) {
          input.disabled = true;
          var wrapper = input.closest(".checkbox-container");
          if (wrapper) wrapper.classList.add("is-disabled");
        });
        Array.from(oldItem.querySelectorAll("label")).forEach(function (label) {
          if (/\(\d+\)/.test(label.textContent)) {
            label.textContent = label.textContent.replace(/\(\d+\)/, "(0)");
          }
        });
        var reference = Array.from(newFilterList.children)[Math.min(index, newFilterList.children.length)] || null;
        newFilterList.insertBefore(oldItem, reference);
        return;
      }
      preserveMissingFilterValues(oldItem, newItem);
    });
  }

  function renderFilters(result, state) {
    if (!filterListEl) return;

    var openState = {};
    Array.from(filterListEl.querySelectorAll(".collapsible-toggle[aria-controls]")).forEach(function (toggle) {
      openState[toggle.getAttribute("aria-controls")] = toggle.getAttribute("aria-expanded") === "true";
    });

    var previousChildren = Array.from(filterListEl.children);

    var html = "";
    FACETS.forEach(function (facet) {
      html += renderCheckboxFacet(facet, result.facets && result.facets[facet], state.filters[facet] || []);
    });

    var tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    // Keep a group open across re-renders if the user had it open, even if it has no active value yet.
    Array.from(tempDiv.querySelectorAll(".collapsible-toggle[aria-controls]")).forEach(function (toggle) {
      var id = toggle.getAttribute("aria-controls");
      if (!openState[id]) return;
      toggle.setAttribute("aria-expanded", "true");
      var content = toggle.nextElementSibling;
      if (content) {
        content.toggleAttribute("open", true);
        content.style.overflow = "visible";
      }
    });

    if (previousChildren.length) {
      var fakeOldList = document.createElement("div");
      previousChildren.forEach(function (child) { fakeOldList.appendChild(child); });
      preserveMissingFilterOptions(fakeOldList, tempDiv);
    }

    filterListEl.innerHTML = "";
    Array.from(tempDiv.children).forEach(function (child) { filterListEl.appendChild(child); });
  }

  // Mirrors snippets/facet-active-filters.liquid: one removable "tag" chip per active value,
  // plus a "clear all" link once more than one filter is active.
  function renderActiveFilters(state) {
    var chips = "";
    var count = 0;

    FACETS.forEach(function (facet) {
      (state.filters[facet] || []).forEach(function (value) {
        count++;
        chips +=
          '<div class="tag"><a href="' + urlWithoutFilterValue(facet, value) + '" data-action="clear-filters" class="tag__icon tap-area" aria-label="' + escapeHtml(pageConfig.deleteLabel) + '">' +
          CLOSE_ICON_SVG + "</a>" + escapeHtml(value) + "</div>";
      });
    });

    if (count > 1) {
      chips += '<a href="' + urlClearAll() + '" data-action="clear-filters" class="tag-link link text--subdued">' + escapeHtml(pageConfig.clearFiltersLabel) + "</a>";
    }

    [activeFiltersEl, activeFiltersMobileEl].forEach(function (el) {
      if (!el) return;
      el.innerHTML = chips;
      el.hidden = count === 0;
    });

    [activeFiltersCountEl, activeFiltersCountMobileEl].forEach(function (el) {
      if (!el) return;
      el.textContent = count;
      el.hidden = count === 0;
    });

    if (clearFiltersLinkEl) {
      clearFiltersLinkEl.href = urlClearAll();
      clearFiltersLinkEl.hidden = count === 0;
    }
  }

  function renderProductCard(hit, index, queryID, indexName) {
    var image = hit.product_image || hit.image;
    if (image) image += (image.indexOf("?") === -1 ? "?" : "&") + "width=600";

    var price = hit.variants_min_price != null ? hit.variants_min_price : hit.price;
    var compareAt = hit.variants_compare_at_price_min != null ? hit.variants_compare_at_price_min : hit.compare_at_price;
    var priceHtml = compareAt && compareAt > price
      ? '<span class="price price--highlight">' + formatMoney(price) + '</span><span class="price price--compare">' + formatMoney(compareAt) + "</span>"
      : '<span class="price">' + formatMoney(price) + "</span>";

    var productUrl = "/products/" + encodeURIComponent(hit.handle);
    var soldOut = hit.inventory_available === false;
    var vendorHtml = window.themeVariables.settings.showVendor && hit.vendor
      ? '<a class="product-item-meta__vendor heading heading--xsmall" href="' + productUrl + '">' + escapeHtml(hit.vendor) + "</a>"
      : "";
    var subtitle = hit.meta && hit.meta.custom && hit.meta.custom.sottotitolo;
    var subtitleHtml = subtitle
      ? '<br><small class="text--small text--subdued text--light">' + escapeHtml(subtitle) + "</small>"
      : "";

    var buyControlHtml = "";
    if (!soldOut && hit.variants_count !== 1) {
      buyControlHtml =
        '<quick-buy-popover href="' + productUrl + '?view=quick-buy-popover" class="popover popover--quick-buy hidden-tablet-and-up"></quick-buy-popover>' +
        '<quick-buy-drawer href="' + productUrl + '?view=quick-buy-drawer" class="drawer drawer--large drawer--quick-buy hidden-phone"></quick-buy-drawer>';
    }

    // data-search-product-id feeds the "recently searched" list in the search drawer (algolia-search.js)
    var insightsAttrs = ' data-search-product-id="' + escapeHtml(hit.id) + '"' + (queryID
      ? ' data-algolia-click data-algolia-index="' + escapeHtml(indexName) + '" data-algolia-query-id="' + escapeHtml(queryID) + '" data-algolia-object-id="' + escapeHtml(hit.objectID) + '" data-algolia-position="' + (index + 1) + '"'
      : "");

    return (
      '<product-item class="product-item' + (soldOut ? " product-item--sold-out" : "") + '">' +
      '<div class="product-item__image-wrapper">' +
      (soldOut ? '<div class="product-item__label-list label-list"><span class="label label--subdued">' + escapeHtml(window.themeVariables.strings.collectionSoldOut) + "</span></div>" : "") +
      '<a href="' + productUrl + '" class="product-item__aspect-ratio aspect-ratio aspect-ratio--square"' + insightsAttrs + '>' +
      (image ? '<img class="product-item__primary-image" loading="lazy" src="' + escapeHtml(image) + '">' : "") +
      "</a>" +
      buyControlHtml +
      "</div>" +
      '<div class="product-item__info"><div class="product-item-meta">' +
      vendorHtml +
      '<a href="' + productUrl + '" class="product-item-meta__title"' + insightsAttrs + '>' + escapeHtml(hit.title) + subtitleHtml + "</a>" +
      '<div class="product-item-meta__price-list-container"><div class="price-list price-list--centered">' + priceHtml + "</div></div>" +
      "</div></div>" +
      "</product-item>"
    );
  }

  function renderProducts(result) {
    productListEl.innerHTML = result.hits.map(function (hit, index) {
      return renderProductCard(hit, index, result.queryID, result.indexName);
    }).join("");
  }

  function renderPagination(result, state) {
    if (result.nbPages <= 1) {
      paginationEl.innerHTML = "";
      return;
    }

    var links = "";
    for (var page = 1; page <= result.nbPages; page++) {
      var isCurrent = page === state.page;
      links += isCurrent
        ? '<span class="pagination__nav-item heading heading--small" aria-current="page">' + page + "</span>"
        : '<a href="?page=' + page + '" data-page="' + page + '" class="pagination__nav-item heading heading--small" aria-label="' + escapeHtml(pageConfig.goToPageTemplate.replace("@page@", page)) + '">' + page + "</a>";
    }

    var prev = state.page > 1
      ? '<a class="pagination__nav-item" rel="prev" aria-label="' + escapeHtml(pageConfig.previousPageLabel) + '" data-page="' + (state.page - 1) + '" href="?page=' + (state.page - 1) + '"><svg focusable="false" width="17" height="14" viewBox="0 0 17 14" class="icon icon--nav-arrow-left icon--direction-aware"><path d="M17 7H2M8 1L2 7l6 6" stroke="currentColor" stroke-width="' + (window.themeVariables.settings.iconStrokeWidth || 2) + '" fill="none"></path></svg></a>'
      : "";
    var next = state.page < result.nbPages
      ? '<a class="pagination__nav-item" rel="next" aria-label="' + escapeHtml(pageConfig.nextPageLabel) + '" data-page="' + (state.page + 1) + '" href="?page=' + (state.page + 1) + '"><svg focusable="false" width="17" height="14" viewBox="0 0 17 14" class="icon icon--nav-arrow-right icon--direction-aware"><path d="M0 7h15M9 1l6 6-6 6" stroke="currentColor" stroke-width="' + (window.themeVariables.settings.iconStrokeWidth || 2) + '" fill="none"></path></svg></a>'
      : "";

    paginationEl.innerHTML = '<page-pagination ajax class="pagination"><nav class="pagination__nav">' + prev + links + next + "</nav></page-pagination>";
  }

  async function loadResults(url, pushState) {
    if (abortController) abortController.abort();
    abortController = new AbortController();

    if (pushState) {
      history.pushState({}, "", url);
    }

    var state = currentState();

    // /search?q= (typed URL, old links...): don't query Algolia, it would be logged as an
    // "Empty Search". Forms can't get here anymore, see search-empty-guard.js.
    if (!state.q.trim()) {
      productListEl.innerHTML = "";
      paginationEl.innerHTML = "";
      countEl.textContent = "";
      if (filterListEl) filterListEl.innerHTML = "";
      emptyStateEl.hidden = true;
      if (emptyQueryEl) emptyQueryEl.hidden = false;
      return;
    }
    if (emptyQueryEl) emptyQueryEl.hidden = true;

    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start"));

    try {
      var result = await fetchAlgolia(state, abortController.signal);

      renderSortSelectedValue(state);
      renderFilters(result, state);
      renderActiveFilters(state);

      if (result.hits.length === 0) {
        productListEl.innerHTML = "";
        paginationEl.innerHTML = "";
        countEl.textContent = "";
        emptyStateEl.hidden = false;
      } else {
        emptyStateEl.hidden = true;
        renderCount(result.nbHits);
        renderProducts(result);
        renderPagination(result, state);
      }

      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end"));

      var scrollTarget = document.querySelector(".product-facet__meta-bar") || facetMainEl;
      if (pushState) {
        requestAnimationFrame(function () {
          scrollTarget.scrollIntoView({ block: "start", behavior: "smooth" });
        });
      }
    } catch (error) {
      if (error.name === "AbortError") return;
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end"));
      throw error;
    }
  }

  async function loadPopularPage() {
    var suggestions = window.algoliaSearchSuggestions;
    if (!suggestions) return;

    var total = parseInt(popularRoot.getAttribute("data-total"), 10) || 50;
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start"));

    try {
      var result = await suggestions.fetch(total);
      [["recent", result.recent], ["popular", result.popular]].forEach(function (group) {
        var groupEl = popularRoot.querySelector('[data-group="' + group[0] + '"]');
        if (!groupEl) return;
        groupEl.querySelector(".product-list__inner").innerHTML = group[1].map(function (hit, index) {
          return renderProductCard(hit, index, null, null);
        }).join("");
        groupEl.hidden = group[1].length === 0;
      });
    } finally {
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end"));
    }
  }

  if (popularRoot) {
    loadPopularPage();
    return;
  }

  root.addEventListener("facet:criteria-changed", function (event) {
    loadResults(event.detail.url, true);
  });
  root.addEventListener("pagination:page-changed", function (event) {
    loadResults(event.detail.url, true);
  });

  window.addEventListener("popstate", function () {
    loadResults(window.location.href, false);
  });

  loadResults(window.location.href, false);
})();
